// extracted by mini-css-extract-plugin
module.exports = {"tncModal":"TncModal_tncModal__j3GGe","title":"TncModal_title__YRdbV","description":"TncModal_description__Q4_UF"};